import { render } from "./RfidPowerSwitch.vue?vue&type=template&id=63855347&scoped=true"
import script from "./RfidPowerSwitch.vue?vue&type=script&lang=ts"
export * from "./RfidPowerSwitch.vue?vue&type=script&lang=ts"

import "./RfidPowerSwitch.vue?vue&type=style&index=0&id=63855347&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63855347"

export default script